import { Jobs } from './Jobs';

export default Jobs;



// WEBPACK FOOTER //
// ./src/components/Jobs/index.js